import { ReactNode } from 'react'
import { User, ChevronDown } from '@stratascratch/icons'
import Button from '../Button'
import Dropdown from '../Dropdown'
import './UserMenu.css'

export interface Props {
  renderLink: (props: {
    href: string
    onClick: () => void
    className: string
    children: ReactNode
  }) => ReactNode
  closeMenu: () => void
}

function UserMenu({ renderLink, closeMenu: closeNavMenu }: Props) {
  return (
    <Dropdown>
      <Dropdown.Toggle>
        {(showMenu, toggleMenu) => (
          <Button
            as="button"
            variant="outline"
            className="text-600"
            size="small"
            onClick={toggleMenu}
          >
            <User />
            Profile
            <ChevronDown className="UserMenu__chevron" data-active={showMenu} />
          </Button>
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {(closeMenu) => (
          <ul className="UserMenu__menu" role="menu">
            <li key="/user">
              {renderLink({
                href: '/user',
                onClick: () => {
                  closeMenu()
                  closeNavMenu()
                },
                className: 'UserMenu__link text-sm block py-3 px-4',
                children: 'Your Performance',
              })}
            </li>
            <li key="/account-settings">
              {renderLink({
                href: '/account-settings',
                onClick: () => {
                  closeMenu()
                  closeNavMenu()
                },
                className: 'UserMenu__link text-sm block py-3 px-4',
                children: 'Account Settings',
              })}
            </li>
          </ul>
        )}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default UserMenu
